<div layout="col" layoutGap="6">
    <div layout="col" layoutGap="4">
        <div layout="row" layoutAlign="center center">
            <h1>{{'Create you account' | translate}}</h1>
        </div>

        <form (ngSubmit)="register()">
            <div [formGroup]="form" layout="col" layoutAlign="center center" layoutGap="2" class="credential-wrapper">
                <p-floatlabel variant="on" [style]="{'width': '100%'}">
                    <input id="email" formControlName="email" pInputText style="width: 100%;" />
                    <label for="email">{{'Email' | translate}}</label>
                </p-floatlabel>

                <p-floatlabel variant="on" [style]="{'width': '100%'}">
                    <input id="password" formControlName="password" pInputText type="password" fluid />
                    <label for="password">{{'Password' | translate}}</label>
                </p-floatlabel>

                <button type="submit" style="display: none"></button>
            </div>
        </form>

        <div>
            @if (auth.createUserError$ | async) {
            <p-message severity="error">{{getFirebaseAuthErrorMessage(auth.createUserError$ | async)}}</p-message>
            }
        </div>

        <p-button [style]="{'width': '100%'}" (click)="register()">{{'Create account' | translate}}</p-button>

        <div layout="row" layoutAlign="center center" layoutGap="0">
            <span>{{'Already have an account?' | translate}}</span>

            <p-button [label]="'Log in' | translate" [routerLink]="['../credentials']" link>
            </p-button>
        </div>
    </div>

    <div style="text-align: center; font-size: 14px;">
        <span>By continuing, you agree to our </span>
        <a style="text-decoration: none; color: var(--p-primary-color);" [routerLink]="['../terms']">Terms
            of Service</a>
        <span> and </span>
        <a style="text-decoration: none; color: var(--p-primary-color);" [routerLink]="['../privacy']">Privacy
            Policy</a>
    </div>




</div>